import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import RaisedButton from 'material-ui/RaisedButton';
import { validateConstraints } from '../../../components/FormWrapper';
import { Col, Row } from 'react-flexbox-grid';

import { TextField } from 'redux-form-material-ui';

const formValidation = values =>
    validateConstraints(values, {
        endpointPrefix: {
            presence: {
                message: '^Bitte geben Sie einen Mandanten ein',
                allowEmpty: false,
            },
        },
        email: {
            presence: {
                message: '^Bitte geben Sie eine E-Mail-Adresse ein',
                allowEmpty: false,
            },
        },
        password: {
            presence: {
                message: '^Bitte geben Sie Ihr Passwort ein',
                allowEmpty: false,
            },
        },
    });

const LoginForm = props => {
    const { handleSubmit, pristine, reset, submitting } = props;
    return (
        <form onSubmit={handleSubmit}>
            <div className="form_container">
                <Row>
                    <Col xs={12} className="form_container">
                        <Row>
                            <Field
                                name="endpointPrefix"
                                component={TextField}
                                type="text"
                                style={{ width: '90%' }}
                                floatingLabelText="Mandant"
                                label="Mandant"
                            />
                        </Row>
                        <Row>
                            <Field
                                name="email"
                                component={TextField}
                                type="text"
                                style={{ width: '90%' }}
                                floatingLabelText="E-Mail-Adresse"
                                label="E-Mail-Adresse"
                            />
                        </Row>
                        <Row>
                            <Field
                                name="password"
                                style={{ width: '90%' }}
                                component={TextField}
                                floatingLabelText="Passwort"
                                type="password"
                                label="Passwort"
                            />
                        </Row>
                    </Col>
                </Row>
            </div>
            <br />
            <Row>
                <Col xs={12} className="form_container">
                    <Row end="xs">
                        <RaisedButton
                            label="Anmelden"
                            primary={true}
                            type="submit"
                            style={{ position: 'absolute', right: '20px', bottom: '20px' }}
                        />
                        <RaisedButton
                            label="Neukunde? Hier registrieren"
                            primary={true}
                            type="submit"
                            style={{ position: 'absolute', left: '20px', bottom: '20px' }}
                            onClick={() => {
                                window.location.href = '/registration';
                            }}
                        />
                    </Row>
                </Col>
            </Row>
        </form>
    );
};

export default reduxForm({ form: 'login' })(LoginForm);
